// Fold (drawing v2.6, `fold()`; standard rule 5): what a person acts on stays
// open; everything else folds into one line that says what is inside, with
// "Show it". Open shows the contents in place; height grows and the content
// fades (200ms), snaps under reduced motion.

import { useId, useState, type ReactNode } from "react";
import { ChevronDown } from "lucide-react";
import { cx } from "./cx";

export function Fold({ title, summary, count, defaultOpen = false, children, className, id }: { title: ReactNode; summary?: ReactNode; count?: ReactNode; defaultOpen?: boolean; children: ReactNode; className?: string; id?: string }) {
  const [open, setOpen] = useState(defaultOpen);
  const bodyId = useId();
  return (
    <section className={cx("pg-card", className)} id={id}>
      <button type="button" className="pg-fold" aria-expanded={open} aria-controls={bodyId} onClick={() => setOpen((o) => !o)}>
        <ChevronDown className="pg-ico" aria-hidden />
        <span className="pg-fold__tx">
          <b>
            {title}
            {count !== undefined && <span className="pg-count" style={{ marginLeft: 8 }}>{count}</span>}
          </b>
          {summary && <span>{summary}</span>}
        </span>
        <span className="pg-btn pg-btn--sm pg-btn--ghost" aria-hidden>
          {open ? "Hide it" : "Show it"}
        </span>
      </button>
      {open && (
        <div className="pg-fold__body" id={bodyId}>
          {children}
        </div>
      )}
    </section>
  );
}
